import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { useLanguage } from "../../contexts/LanguageContext";
import { SectionCTA } from "../shared/SectionCTA";

export const ProcessSection = () => {
  const { language, translations: t } = useLanguage();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section id="process" className="py-20 md:py-28 bg-white scroll-mt-20" data-testid="process-section" ref={ref}>
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
        >
          <span className="text-[#C4956A] font-semibold mb-2 block">{t.process.label}</span>
          <h2 className="font-['Heebo'] text-3xl md:text-4xl lg:text-5xl font-bold text-[#2C2C2C] mb-4">
            {t.process.title}
          </h2>
          <div className="w-20 h-1 bg-[#C4956A] mx-auto" />
        </motion.div>

        <div className="grid md:grid-cols-4 gap-8">
          {t.process.steps.map((step, i) => (
            <motion.div
              key={i}
              className="relative text-center"
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ delay: i * 0.15 }}
            >
              {i < t.process.steps.length - 1 && (
                <div className="hidden md:block absolute top-6 left-0 w-full h-0.5 bg-[#C4956A]/20" style={{ transform: 'translateX(-50%)' }} />
              )}
              <div className="w-12 h-12 rounded-full bg-[#C4956A] text-white font-bold text-xl flex items-center justify-center mx-auto mb-4 relative z-10">
                {i + 1}
              </div>
              <h3 className="font-['Heebo'] text-lg font-bold text-[#2C2C2C] mb-2">{step.title}</h3>
              <p className="text-[#2C2C2C]/60 text-sm">{step.desc}</p>
            </motion.div>
          ))}
        </div>

        <SectionCTA 
          text={language === 'he' ? "מוכנים להתחיל את התהליך?" : "Ready to start the process?"} 
          buttonText={language === 'he' ? "צרו קשר עכשיו" : "Contact us now"} 
        />
      </div>
    </section>
  );
};
